/** Ledger kind color on the pin hover tooltip, reused on the pin header. */
export const LEDGER_ACCENT = '#fbbf24';

/**
 * Same amber as the tooltip. Darkened so the claim stays readable
 * on the white pin header.
 */
export const LEDGER_ACCENT_ON_LIGHT = '#b45309';
